import PropTypes from 'prop-types'
import { Table, Tbody, Thead, Tr } from '@chakra-ui/react'
import { numberFormatter } from 'lib'
import { ThMetric, TdMetric } from './common'

export const MetricsStaging = ({ data }) => {
  return (
    <Table>
      <Thead>
        <Tr>
          <ThMetric w="7%">Department</ThMetric>
          <ThMetric w="7%">Sub Department</ThMetric>
          <ThMetric w="10%">Measure</ThMetric>
          <ThMetric w="10%">Unit of Measure</ThMetric>
          {data.dateHeaders.map(dateHeader => <ThMetric key={dateHeader.date}>{dateHeader.text}</ThMetric>)}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <TdMetric rowSpan={9} colSpan={2}>Staging</TdMetric>
          <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.staging.total.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.staging.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>New Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.staging.new.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.staging.new.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Out Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.staging.out.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.staging.out.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Greater Than 14 Days</TdMetric>
          <TdMetric>Current</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.staging.old.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>On Hold</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.staging.onhold.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.staging.onhold.amount)}</TdMetric>)}
        </Tr>
      </Tbody>
    </Table>
  )
}

MetricsStaging.propTypes = {
  data: PropTypes.object
}
